import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import authService from '../utils/auth';

// 路由保护组件
function ProtectedRoute({ children, requireAdmin = false, requireStaff = false }) {
  const location = useLocation();

  // 检查是否已登录
  if (!authService.isAuthenticated()) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // 检查是否需要管理员权限
  if (requireAdmin && !authService.isAdmin()) {
    return <Navigate to="/unauthorized" replace />;
  }

  // 检查是否需要管理人员权限（管理员或运营）
  if (requireStaff && !authService.isStaff()) {
    return <Navigate to="/unauthorized" replace />;
  }

  // 检查销售人员是否试图访问管理员页面
  const userInfo = authService.getUserInfo();
  if (userInfo && userInfo.role === 'salesperson' && location.pathname.startsWith('/admin')) {
    return <Navigate to="/sales" replace />;
  }

  // 管理员 / 运营可以进销售端。
  // 为什么放开（2026-08-28）：后台人员也可能自己带客人——TTOUR 订单按 broker 挂到他名下，
  // 而「代客上传护照」的两步 OCR 流程只在销售端页面（SalesTours / SalesTourists）有，
  // 管理端的出团管理和游客管理都没有。被这条重定向挡住的结果是：管理员自己的客人，
  // 他自己反而传不了护照（实例：管理员 Stephen 名下 11/05 东南亚邮轮游 2 位客人）。
  // 数据范围不会变宽：销售端按 salespersonId === 当前用户 过滤，且这些角色在管理端本来就能看全部。
  // finance 仍然挡住——财务不带客人，没有进销售端的理由。
  if (userInfo && userInfo.role === 'finance' && location.pathname.startsWith('/sales')) {
    return <Navigate to="/admin" replace />;
  }

  // 导游不能访问管理端和销售端
  if (userInfo && userInfo.role === 'guide' && (location.pathname.startsWith('/admin') || location.pathname.startsWith('/sales'))) {
    return <Navigate to="/unauthorized" replace />;
  }

  return children;
}

export default ProtectedRoute;
